import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagSI = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M48.445 16.305H21.739V9.783H8.696v6.522H1.555A24.946 24.946 0 0 0 0 25c0 3.058.55 5.988 1.555 8.696L25 35.87l23.445-2.174A24.946 24.946 0 0 0 50 25c0-3.058-.55-5.987-1.555-8.695Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25 50c10.75 0 19.913-6.784 23.445-16.304H1.555C5.088 43.216 14.251 50 25 50Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M8.696 16.304v2.174c0 4.992 6.521 6.522 6.521 6.522s6.522-1.53 6.522-6.522v-2.174l-2.174 2.174-4.348-3.26-4.347 3.26-2.174-2.174Z"
}));
FlagSI.displayName = 'FlagSI';
export default withFlagWrapper(FlagSI);
//# sourceMappingURL=index.js.map